import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'CommonModal',
  props: {
  canClose: {
    type: Boolean,
    default: true,
  }
},
  emits: ["on-close-by-button"],
  setup(__props, { expose: __expose }) {





const blackout = ref<HTMLDivElement>();
const zIndexRef = ref<number>(2);

__expose({
  open: (params: { zIndex?: number } = {}) => {
    if (blackout.value) {
      blackout.value?.classList.add("open");
    }
    zIndexRef.value = params?.zIndex ?? 2;
  },
  close: closeButton,
});

function closeButton() {
  if (blackout.value) {
    blackout.value?.classList.remove("open");
  }
}


const __returned__ = { blackout, zIndexRef, closeButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})